var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "category-menu", on: { click: _vm.onClose } },
    [
      _c(
        "div",
        { staticClass: "buttonContainer" },
        _vm._l(_vm.categories, function (item, index) {
          return _c("RectangleButton", {
            key: item + index,
            staticClass: "button",
            attrs: {
              selector: "",
              slanted: "",
              color: "blue",
              label: _vm.$t(`cat_${item}`),
              inactive: _vm.activeCategory !== item,
              func: () => _vm.onCategorySelected(item),
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }